export const REDIRECT_SERVER_HOST = 'https://priceless-euclid-bf53ed.netlify.app/';

export const YOUTUBE_SEARCH_PATH = 'youtube/v3/search';
